"use client"

import { useState, useContext, useEffect, useRef } from "react"
import { ErpContext } from "../../context/ErpContext.js"

import { useParams } from "react-router-dom"

import {
  IconButton,
  TextField,
  Button,
  Autocomplete,
  Checkbox,
  Collapse,
  Typography,
  Box,
  Grid,
  Divider,
  Tooltip,
  Card,
  CardContent,
  alpha,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  CircularProgress,
} from "@mui/material"

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import { red } from "@mui/material/colors"
import DeleteIcon from "@mui/icons-material/Delete"
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt"
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart"
import ReceiptIcon from "@mui/icons-material/Receipt"
import PersonIcon from "@mui/icons-material/Person"
import SearchIcon from "@mui/icons-material/Search"
import RestartAltIcon from "@mui/icons-material/RestartAlt"

import "./GestionGenerarPresupuestoComponent.css"
import ModalEntidadCliente from "../adminComponent/ModalEntidadClienteComponent.js"
import CrearEntidadClienteModalComponent from "../adminComponent/CrearEntidadClienteModalComponent.js"

import { styled } from "@mui/material/styles"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell, { tableCellClasses } from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"

import ModalFacturaComponent from "./ModalFacturaComponent.js"

import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

// Función helper para redondear a 2 decimales (operaciones monetarias)
const roundToTwoDecimals = (value) => {
  return Math.round(value * 100) / 100
}

// Mantener alias para compatibilidad con código existente
const truncateToTwoDecimals = roundToTwoDecimals




const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#5b5b5f",
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.light, 0.1),
    transition: "background-color 0.2s ease",
  },
  // Reducir la altura de las filas
  "& .MuiTableCell-root": {
    padding: "6px 8px", // Reducir padding vertical y horizontal
    height: "40px", // Altura fija más compacta
  },
}))

const GestionGenerarPresupuestoComponent = () => {
  const { id } = useParams()

  const {
    item,
    getItem,
    getItemTresLetras,
    itemTresLetras,
    entidadesClientesTresLetras,
    getEntidadesClientesTresLetras,
    postTransaccionItem,
    postTransaccion,
    itemUbicacion,
    getItemUbicacion,
    getEntidad,
    getTipoEntidad,
    getTipoMedioDePago,
    getUsuario,
    transaccionItem,
    putTransaccion,
    updateTransaccionItem,
    getTransaccionItemsByTransactionId,
    deleteTransaccionItemNoLista,
    getEntidadByID,
    getItemUbicacionFilterByUbicacion,
    getItemById,
    getTransaccionFilter,
    arrayItemTresLetras,
    getUbicacion,
    ubicaciones,
    getNegocio,
    negocios,
    itemAtributoNoEliminados,
    getItemAtributoNoEliminados,
    getListaMontosByIdItemIdEntidad,
    isNavbarCollapsed,
    getIncluirImpuestos,
    impuestos,
    arrayImpuestos,
    getImpuestos,
    getImpuestoItem,
    updateImpuestoItem,
    postTransaccionImpuestoItem,
    updateTransaccionImpuestoItem,
    getTransaccionImpuestoItems,
    getIvaAFIP,
    getTop10ItemVentas,
    user, // 🔒 Usuario del contexto para verificar permisos
    tieneAccesoFuncionalidad, // 🔒 Función de verificación de permisos granulares
    updateItemPrecioListaId, // 🔒 Función para actualizar precio en lista de precios
  } = useContext(ErpContext)

  const [descripcionTransaccion, setDescripcionTransaccion] = useState("")
  const [selectedItem, setSelectedItem] = useState(null)
  const [searchText, setSearchText] = useState("")
  const [searchTextCliente, setSearchTextCliente] = useState("")
  const [filteredItems, setFilteredItems] = useState([])
  const [itemList, setItemList] = useState([])
  const [dniCliente, setDniCliente] = useState("")
  const [idDniExistente, setIdDniExistente] = useState("")

  const [cantidadInputs, setCantidadInputs] = useState({});

  const [precioTotal, setPrecioTotal] = useState(0)
  const [cantidadItemsSelect, setCantidadItemsSelect] = useState(0)
  const [cantidadItemsInvocados, setCantidadItemsInvocados] = useState(0)

  const [entidadExistente, setEntidadExistente] = useState(null)
  const [abrirModalCrearCliente, setAbrirModalCrearCliente] = useState(false)
  const [abrirModalEntidadCliente, setAbrirModalEntidadCliente] = useState(false)

  const [valorDescuento, setValorDescuento] = useState(0)
  const [porcentajeDescuento, setPorcentajeDescuento] = useState(0)

  const [entidadAEditar, setEntidadAEditar] = useState(null)
  const [isEditing, setIsEditing] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [transaccionData, setTransaccionData] = useState(null)
  const [itemsTransaccion, setItemsTransaccion] = useState([])
  const [entidadFactura, setEntidadFactura] = useState([])

  const [tempValorDescuento, setTempValorDescuento] = useState("0")
  const [tempPorcentajeDescuento, setTempPorcentajeDescuento] = useState("0")
  const [precioBaseTotal, setPrecioBaseTotal] = useState(0)
  const [montoTotalDescuentos, setMontoTotalDescuentos] = useState(0)
  const [aplicarDescuento, setAplicarDescuento] = useState(false)

  const [openModalMedioPago, setOpenModalMedioPago] = useState(false)
  const [filteredTransaccionItems, setFilteredTransaccionItems] = useState([])
  const [selectedUbicacion, setSelectedUbicacion] = useState(null)
  const [selectedNegocio, setSelectedNegocio] = useState(null)

  const [checkboxFacturaNegro, setCheckboxFacturaNegro] = useState(true)
  const [aceptarImpuestos, setAceptarImpuestos] = useState(false)
  const [mostrarIva, setMostrarIva] = useState(false)
  const [precioTotalConImpuestos, setPrecioTotalConImpuestos] = useState(0)

  // Estado para almacenar los impuestos de los items
  const [itemImpuestos, setItemImpuestos] = useState({})

  // Estado para trackear cambios de impuestos que necesitan ser guardados
  const [impuestosModificados, setImpuestosModificados] = useState({})
  const [topItemsVentas, setTopItemsVentas] = useState([])
  const [loading, setLoading] = useState(false)

  // 🔒 VERIFICAR PERMISO GRANULAR: Precio editable en presupuestos
  // IDs definidos en: server/services/menuAccesoValidator.js (VENTAS3)
  const precioEnPresupuestoEditable = tieneAccesoFuncionalidad(user, 'VENTAS3', 'precioEnPresupuestoEditable')

  // Función para obtener impuestos válidos para un item específico
  const getImpuestosValidosParaItem = (itemId, impuestoActual = null) => {
    const impuestosAFIP = getIvaAFIP();

    // Si hay un impuesto actual configurado para este item
    if (impuestoActual && impuestoActual.porcentaje !== undefined) {
      // Buscar si existe un impuesto de AFIP con el mismo porcentaje
      const impuestoAFIPCoincidente = impuestosAFIP.find(imp =>
        Math.abs(imp.porcentaje - impuestoActual.porcentaje) < 0.01
      );

      // Si encontramos un impuesto de AFIP con el mismo porcentaje, usar ese
      if (impuestoAFIPCoincidente) {
        return impuestosAFIP;
      }

      // Si no hay coincidencia, agregar el impuesto personalizado
      return [
        {
          id: impuestoActual.idImpuesto || `custom_${impuestoActual.porcentaje}`,
          descripcion: impuestoActual.descripcionImpuesto || `Impuesto ${impuestoActual.porcentaje}%`,
          porcentaje: impuestoActual.porcentaje,
          codigoAFIP: "CUSTOM"
        },
        ...impuestosAFIP
      ];
    }

    // Retornar solo los impuestos válidos de AFIP
    return impuestosAFIP;
  };

  // Función para actualizar el impuesto de un item específico
  const handleUpdateItemImpuesto = (index, newIvaPercentage) => {
    const updatedItems = [...itemList];
    const item = updatedItems[index];

    // Encontrar el impuesto correspondiente al porcentaje seleccionado
    const impuestosValidos = getImpuestosValidosParaItem(item.idItem, item.impuestoData);
    const impuestoSeleccionado = impuestosValidos.find(imp =>
      Math.abs(imp.porcentaje - newIvaPercentage) < 0.01
    );

    // Actualizar el item con el nuevo impuesto
    item.ivaPercentage = newIvaPercentage;
    item.impuestoData = {
      idImpuesto: impuestoSeleccionado?.id || null,
      porcentaje: newIvaPercentage,
      descripcionImpuesto: impuestoSeleccionado?.descripcion || `IVA ${newIvaPercentage}%`,
      idIva: impuestoSeleccionado?.idIva || 1,
    };

    // Recalcular precios
    const precioSinIva = checkboxFacturaNegro
      ? truncateToTwoDecimals(item.precio / (1 + newIvaPercentage / 100) * (1 - (item.porcentajeDescuento || 0) / 100))
      : item.precio;
    const montoIva = checkboxFacturaNegro
      ? truncateToTwoDecimals(precioSinIva * (newIvaPercentage / 100))
      : 0;

    item.precioSinIva = precioSinIva;
    item.montoIva = montoIva;

    setItemList(updatedItems);
    setFilteredTransaccionItems(updatedItems);

    // Marcar que este item tiene un impuesto modificado
    setImpuestosModificados(prev => ({
      ...prev,
      [item.idItem]: {
        idImpuesto: impuestoSeleccionado?.id || null,
        porcentajeOriginal: item.impuestoData?.porcentaje || 21,
        porcentajeNuevo: newIvaPercentage,
        descripcion: item.descripcion
      }
    }));

    // Actualizar totales
    updateTotals(updatedItems);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        await getTipoEntidad()
        await getTipoMedioDePago()
        await getUsuario()
        await getUbicacion()
        await getNegocio()
        await getItemAtributoNoEliminados()
        await getImpuestos()
        const result = await getIncluirImpuestos()

        // ✅ Cargar top 10 items más vendidos (como en GestionGenerarVenta)
        try {
          const top10items = await getTop10ItemVentas()
          if (top10items) {
            // Mapeo para extraer los datos internos del item (igual que en GestionGenerarVenta)
            const mappedTop10 = top10items.map(({ item, ventas }) => ({
              id: item.id,
              codigo: item.codigo,
              descripcion: item.descripcion,
              codigoScanner: item.codigoScanner,
            }))
            setTopItemsVentas(mappedTop10)
            console.log("Top 10 items más vendidos cargados:", mappedTop10)
          }
        } catch (error) {
          console.log("No se pudieron cargar los top items:", error)
          setTopItemsVentas([])
        }
        console.log("Resultado de impuestos:", result)
        if (result.valorParametro == "0") {
          setCheckboxFacturaNegro(true)
          setAceptarImpuestos(true)
        } else {
          setCheckboxFacturaNegro(false)
          setAceptarImpuestos(false)
        }

        // ✅ Cargar cliente por defecto (ID 1) como en GestionGenerarVenta
        if (!id) {
          try {
            const defaultEntidad = await getEntidadByID(1)
            if (defaultEntidad) {
              setDniCliente({
                label: `${defaultEntidad.descripcion} ${defaultEntidad.apellido} ${defaultEntidad.dniCuitCuil}`,
                descripcion: defaultEntidad.descripcion || null,
                dniCuitCuil: defaultEntidad.dniCuitCuil,
                id: defaultEntidad.id,
                apellido: defaultEntidad.apellido,
                telefono: defaultEntidad.telefono || null,
                email: defaultEntidad.email || null,
                direccion: defaultEntidad.direccion || null,
                localidad: defaultEntidad.localidad || null,
                provincia: defaultEntidad.provincia || null,
                idTipoEntidad: defaultEntidad.idTipoEntidad,
              })
              console.log("Cliente por defecto cargado:", defaultEntidad)
            }
          } catch (error) {
            console.log("No se pudo cargar el cliente por defecto:", error)
          }
        }

        // ✅ Configurar ubicación y negocio por defecto (ID 1) como en GestionGenerarVenta
        const ubicacionTraido = await getUbicacion()
        const negocioTraido = await getNegocio()

        // Configurar la ubicación predeterminada
        const defaultUbicacion = ubicacionTraido.find((it) => it.id === 1)
        const defaultNegocio = negocioTraido.find((it) => it.id === 1)
        if (defaultUbicacion) {
          setSelectedUbicacion({
            id: defaultUbicacion.id,
            label: defaultUbicacion.descripcion,
          })
          console.log("Ubicación por defecto cargada:", defaultUbicacion)
        }
        if (defaultNegocio) {
          setSelectedNegocio({
            id: defaultNegocio.id,
            label: defaultNegocio.descripcion,
          })
          console.log("Negocio por defecto cargado:", defaultNegocio)
        }

        // ✅ Focus automático al Autocomplete como en GestionGenerarVenta
        if (autocompleteRef.current) {
          autocompleteRef.current.focus()
        }

        console.log("Datos cargados correctamente")
        setLoading(false)
      } catch (error) {
        console.error("Error al cargar los datos:", error)
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  // Cada vez que itemList cambie, inicializamos el string a partir de la cantidad numérica
  useEffect(() => {
    const init = {};
    itemList.forEach((it, i) => {
      init[i] = it.cantidad.toString();
    });
    setCantidadInputs(init);
  }, [itemList]);

  useEffect(() => {
    if (aplicarDescuento == false) {
      setTempValorDescuento(0)
      setTempPorcentajeDescuento(0)
    }
  }, [aplicarDescuento])

  useEffect(() => {
    const fetchData = async () => {
      console.log("entro el id de la carga en editar")
      if (id) {
        try {
          const filteredTransacciones = await getTransaccionFilter(id)

          if (filteredTransacciones) {
            const filteredEntidadesTransaccion = await getEntidadByID(filteredTransacciones.idEntidad)
            console.log("Transacciones filtradas:", filteredTransacciones)
            console.log("Entidades filtradas:", filteredEntidadesTransaccion)

            setTempValorDescuento(filteredTransacciones.montoDescuento)
            setTempPorcentajeDescuento(filteredTransacciones.porcentajeDescuento)

            setDniCliente({
              label: `${filteredEntidadesTransaccion?.descripcion} ${filteredEntidadesTransaccion?.apellido} ${filteredEntidadesTransaccion?.dniCuitCuil}`,
              descripcion: filteredEntidadesTransaccion?.descripcion || null,
              dniCuitCuil: filteredEntidadesTransaccion?.dniCuitCuil,
              id: filteredEntidadesTransaccion?.id,
              apellido: filteredEntidadesTransaccion?.apellido,
              telefono: filteredEntidadesTransaccion?.telefono || null,
              email: filteredEntidadesTransaccion?.email || null,
              direccion: filteredEntidadesTransaccion?.direccion || null,
              localidad: filteredEntidadesTransaccion?.localidad || null,
              provincia: filteredEntidadesTransaccion?.provincia || null,
              idTipoEntidad: filteredEntidadesTransaccion?.idTipoEntidad,
            })

            setIdDniExistente(filteredTransacciones.idEntidad)
          }
          const filteredItems = await getTransaccionItemsByTransactionId(Number(id))

          console.log(filteredItems)

          // Manejo asíncrono del mapeo
          const mappedItems = await Promise.all(
            filteredItems.map(async (filteredItem) => {
              const ubicacionItem = await getItemUbicacionFilterByUbicacion(
                filteredItem.idItem,
                filteredTransacciones.idUbicacion,
              )

              const precioListaItem = await getListaMontosByIdItemIdEntidad(
                filteredTransacciones.idEntidad,
                filteredItem.idItem,
                filteredTransacciones.idUbicacion,
              )

              // Obtener impuesto del item de forma segura (sin try-catch que rompa el flujo)
              let itemImpuesto = null
              try {
                itemImpuesto = await getImpuestoItem(filteredItem.idItem)
                console.log("Impuesto del item:", itemImpuesto)

                // Guardar el impuesto original en el estado (sin modificar)
                setItemImpuestos(prev => ({
                  ...prev,
                  [filteredItem.idItem]: itemImpuesto
                }))
              } catch (error) {
                console.log("No se encontró impuesto específico para el item:", filteredItem.idItem)
                // Si falla, usar el IVA por defecto sin romper el flujo
                itemImpuesto = {
                  idItem: filteredItem.idItem,
                  idImpuesto: null,
                  porcentaje: 21,
                  descripcionImpuesto: "IVA General"
                }

                // También guardar este impuesto por defecto
                setItemImpuestos(prev => ({
                  ...prev,
                  [filteredItem.idItem]: itemImpuesto
                }))
              }

              console.log("precioListaItem ", precioListaItem)
              console.log("precioListaItem ", precioListaItem.monto)

              const precioItem = precioListaItem ? precioListaItem.monto : 0

              const itemData = await getItemById(filteredItem.idItem)

              console.log(filteredItem)

              // Usar el impuesto específico del item si está disponible, sino usar el por defecto
              const itemIvaPercentage = itemImpuesto?.porcentaje || 21
              const precioSinIva = truncateToTwoDecimals(precioItem / (1 + itemIvaPercentage / 100) * (1 - (filteredItem.porcentajeDescuento || 0) / 100))
              const montoIva = truncateToTwoDecimals(precioSinIva * (itemIvaPercentage / 100))

              console.log('precioSinIva: ', precioSinIva)
              console.log('itemIvaPercentage usado: ', itemIvaPercentage, 'del impuesto:', itemImpuesto?.porcentaje)

              // Buscar si el impuesto actual coincide con algún impuesto de AFIP
              const impuestosAFIP = getIvaAFIP();
              const impuestoAFIPCoincidente = impuestosAFIP.find(imp =>
                Math.abs(imp.porcentaje - itemIvaPercentage) < 0.01
              );

              return {
                ...filteredItem,
                descripcion: itemData?.descripcion || "Descripción no disponible",
                codigo: itemData?.codigo || "Código no disponible",
                stock: ubicacionItem[0].inventario || "No disponible",
                precio: precioItem || "No disponible",
                precioSinIva: precioSinIva, // Nuevo campo: precio sin IVA
                montoIva: montoIva, // Nuevo campo: monto del IVA
                ivaPercentage: itemIvaPercentage, // Porcentaje de IVA aplicado (prioriza impuesto específico)
                porcentajeDescuento: filteredItem.porcentajeDescuento || 0,
                idItem: itemData.id,
                // Información adicional del impuesto para manejar cambios
                impuestoData: {
                  idImpuesto: impuestoAFIPCoincidente?.id || itemImpuesto?.idImpuesto || null,
                  porcentaje: itemIvaPercentage,
                  descripcionImpuesto: impuestoAFIPCoincidente?.descripcion || itemImpuesto?.descripcionImpuesto || "IVA General",
                  idIva: impuestoAFIPCoincidente?.idIva || 1,
                }
              }
            }),
          )

          console.log("mappedItems: " + mappedItems)


          setItemList(mappedItems)
          setFilteredTransaccionItems(mappedItems)
          setCantidadItemsInvocados(mappedItems.length)
          setCantidadItemsSelect()
          updateTotals(mappedItems)
        } catch (error) {
          console.error("Error al obtener datos:", error)
        }
      }
    }
    fetchData()
  }, [id])

  // Función auxiliar para actualizar totales y descuentos
  const updateTotals = (items) => {
    const updatedTotal = items.reduce((total, item) => {
      const itemIvaPercentage = item.ivaPercentage
      /*const precioParaCalculo = checkboxFacturaNegro 
        ? truncateToTwoDecimals(item.precio / (1 + itemIvaPercentage / 100))  // Precio sin IVA
        : item.precio;  // Precio original*/

      const precioParaCalculo = item.precio // Siempre usar precio original para el total

      const itemTotal = truncateToTwoDecimals(
        item.cantidad * precioParaCalculo * (1 - (item.porcentajeDescuento || 0) / 100),
      )
      return truncateToTwoDecimals(total + itemTotal)
    }, 0)

    setPrecioBaseTotal(updatedTotal)
    setPrecioTotal(updatedTotal)
  }

  const generateItemLabel = (item) => {
    // Filtrar los atributos no eliminados
    const activeAttributes = itemAtributoNoEliminados.filter((attr) => !attr.eliminado)

    // Crear el label concatenando los atributos activos
    const attributeValues = activeAttributes
      .map((attr, index) => {
        // Verificar si el valor del atributo es null o undefined, y asignar un valor predeterminado en ese caso
        const attributeValue = item[`itemDatoAtributo${index + 1}`]
        return attributeValue ? attributeValue : "" // Si es null o undefined, mostramos un valor vacío
      })
      .join(" ")

    // Generar el label final con el código y descripción, y los atributos activos
    return `${item.codigo} - ${item.descripcion} - ${attributeValues} - ${item.codigoScanner}`
  }

  // useEffect para actualizar el total cada vez que se modifica itemList o filteredTransaccionItems
  useEffect(() => {
    if (id) {
      updateTotals(filteredTransaccionItems)
    } else {
      updateTotals(itemList)
    }
  }, [itemList, filteredTransaccionItems, checkboxFacturaNegro])

  // ✅ useEffect para manejar la lógica de búsqueda (igual que en GestionGenerarVenta)
  useEffect(() => {
    if (searchText.length >= 3) {
      arrayItemTresLetras([])
      getItemTresLetras(searchText)
      agregarItemRapido()
    } else {
      // ✅ Mostrar top 10 items cuando no hay texto de búsqueda (como en GestionGenerarVenta)
      arrayItemTresLetras([])
      arrayItemTresLetras(topItemsVentas)
      setFilteredItems([])
    }
  }, [searchText, topItemsVentas])

  const agregarItemRapido = async () => {
    await handleAddItem()
  }

  // TRES LETRAS PERO PARA ENTIDADES CLIENTES
  useEffect(() => {
    if (searchTextCliente.length >= 3) {
      getEntidadesClientesTresLetras(searchTextCliente, 1)
    } else {
      setFilteredItems([])
    }
  }, [searchTextCliente])

  // Efecto para calcular precios con impuestos
  useEffect(() => {
    // Calcular subtotal SIN descuentos (precio × cantidad)
    const subtotalSinDescuentos = itemList.reduce((total, item) => {
      const precioParaCalculo = item.precio // Precio original siempre
      return truncateToTwoDecimals(total + item.cantidad * precioParaCalculo)
    }, 0)

    setPrecioBaseTotal(subtotalSinDescuentos)

    // Calcular el monto total de descuentos aplicados a cada línea
    const totalDescuentos = itemList.reduce((total, item) => {
      const precioItem = item.cantidad * item.precio
      const descuentoItem = truncateToTwoDecimals(precioItem * (item.porcentajeDescuento || 0) / 100)
      return truncateToTwoDecimals(total + descuentoItem)
    }, 0)
    
    setMontoTotalDescuentos(totalDescuentos)

    // Calcular total con descuentos aplicados
    const updatedTotal = subtotalSinDescuentos - totalDescuentos

    if (checkboxFacturaNegro) {
      if (impuestos.length > 0) {
        // Verificar si los impuestos están incluidos o no
        const impuestosIncluidos = impuestos.every((impuesto) => impuesto.incluidoEnPrecio)

        if (impuestosIncluidos) {
          // Desglosar impuestos si ya están en el precio
          setMostrarIva(true)
          const totalSinImpuestos = impuestos
            .filter((impuesto) => !impuesto.eliminado)
            .reduce((base, impuesto) => truncateToTwoDecimals(base / (1 + impuesto.porcentaje / 100)), updatedTotal)

          const totalImpuestos = truncateToTwoDecimals(updatedTotal - totalSinImpuestos)

          setPrecioTotal(updatedTotal)
          setPrecioTotalConImpuestos(truncateToTwoDecimals(updatedTotal + totalImpuestos))
        } else {
          setMostrarIva(false)

          // Calcular impuestos adicionales si NO están incluidos
          const totalImpuestos = impuestos
            .filter((impuesto) => !impuesto.eliminado)
            .reduce(
              (acumulador, impuesto) =>
                truncateToTwoDecimals(acumulador + truncateToTwoDecimals((updatedTotal * impuesto.porcentaje) / 100)),
              0,
            )

          const finalTotal = truncateToTwoDecimals(updatedTotal + totalImpuestos)
          setPrecioTotal(finalTotal)
          setPrecioTotalConImpuestos(finalTotal)
        }
      } else {
        setPrecioTotal(updatedTotal)
        setPrecioTotalConImpuestos(updatedTotal)
      }
    } else {
      // CAMBIO: Incluso cuando checkboxFacturaNegro es true, usar el precio original para el total
      setPrecioTotal(updatedTotal)
      setPrecioTotalConImpuestos(updatedTotal)
    }
  }, [itemList, impuestos, checkboxFacturaNegro])

  const applyDiscounts = () => {
    const porcentajeDesc = truncateToTwoDecimals(Number.parseFloat(tempPorcentajeDescuento) || 0)

    // Sumar o restar descuentos a cada item
    if (itemList.length > 0) {
      const updatedItemList = itemList.map(item => {
        const descuentoActual = item.porcentajeDescuento || 0
        let nuevoDescuento = descuentoActual + porcentajeDesc
        
        // Validación: Máximo 100%, mínimo 0%
        if (nuevoDescuento > 100) {
          nuevoDescuento = 100
        }
        if (nuevoDescuento < 0) {
          nuevoDescuento = 0
        }
        
        return {
          ...item,
          porcentajeDescuento: nuevoDescuento
        }
      })

      setItemList(updatedItemList)
      console.log('Descuento general sumado a todos los items:', porcentajeDesc + '%')

      // Resetear el input después de aplicar
      setTempPorcentajeDescuento("0")
      
      // Forzar re-renderizado
      setTimeout(() => {
        setItemList([...updatedItemList])
      }, 0)
    }
  }

  // Función para limpiar descuentos de todos los items
  const limpiarDescuentosItems = () => {
    if (itemList.length > 0) {
      const updatedItemList = itemList.map(item => ({
        ...item,
        porcentajeDescuento: 0
      }))
      setItemList(updatedItemList)
      setTempPorcentajeDescuento("0")
      console.log('Descuentos de items limpiados')

      // Forzar re-renderizado para que los campos se actualicen
      setTimeout(() => {
        setItemList([...updatedItemList])
      }, 0)
    }
  }

  const handleTransaccionSubmit = async (leerCliente) => {
    let entidadEncontrada = null
    try {
      if (leerCliente === true) {
        let dniExistentePorActualizacion = 0

        if (id) {
          console.log(idDniExistente)
          dniExistentePorActualizacion = idDniExistente
        } else {
          dniExistentePorActualizacion = dniCliente.id
        }

        entidadEncontrada = await getEntidadByID(dniExistentePorActualizacion)

        if (!entidadEncontrada) {
          console.log("Tipo de entidad 'Cliente' no encontrado")
          setAbrirModalEntidadCliente(true)
          return
        }

        if (entidadEncontrada) {
          setEntidadFactura(entidadEncontrada)
          console.log("Entidad encontrada:", entidadEncontrada)
        } else {
          console.log("DNI no encontrado entre los clientes")
          setEntidadExistente(null)
          setAbrirModalEntidadCliente(true)
          return
        }
      } else {
        entidadEncontrada = { id: null }
      }

      let transaccionResponse

      // Crear la transacción
      console.log(precioTotal)
      if (id) {
        // Si hay un ID, actualizar la transacción existente
        transaccionResponse = await putTransaccion(
          id, // ID de la transacción a actualizar
          precioTotal, //montoTotal
          3, //idTipoTransaccion
          1, //idMoneda
          entidadEncontrada.id, //idEntidad
          1, //idSubCategoriaTransaccion
          descripcionTransaccion, //descripcion
          1, //idUsuario
          selectedUbicacion.id, //idUbicacion
          selectedNegocio.id, //idNegocio
          tempValorDescuento, // montoDescuento en el total
          tempPorcentajeDescuento, // porcentajeDescuento en el total
        )
      } else {
        console.log(precioTotal, entidadEncontrada, selectedUbicacion, selectedNegocio)
        // Crear una nueva transacción
        transaccionResponse = await postTransaccion(
          precioTotal, //montoTotal
          3, //idTipoTransaccion
          entidadEncontrada.id, //idEntidad
          null, //idSubCategoriaTransaccion
          descripcionTransaccion, //descripcion
          1, //idUsuario
          selectedUbicacion.id, //idUbicacion
          selectedNegocio.id, //idNegocio
          tempValorDescuento, // montoDescuento en el total
          tempPorcentajeDescuento, // porcentajeDescuento en el total
        )
      }

      const idTransaccion = transaccionResponse.data.id

      // Obtener ítems de la transacción actual desde la base de datos
      const existingTransaccionItems = await getTransaccionItemsByTransactionId(idTransaccion)

      console.log("existingTransaccionItems: " + existingTransaccionItems)

      const existingItemIds = existingTransaccionItems.map((item) => item.idItem)

      console.log("existingItemIds: " + existingItemIds)

      const itemListIds = itemList.map((item) => item.idItem)

      console.log("itemListIds: " + itemListIds)

      console.log(itemList)

      // Procesar items válidos
      const preciosActualizados = []
      for (const it of itemList) {
        if (it.idItem && it.cantidad) {
          // 🔒 Si el permiso está activo, actualizar el precio en la lista de precios del cliente
          if (precioEnPresupuestoEditable && entidadEncontrada?.id) {
            try {
              await updateItemPrecioListaId(it.idItem, entidadEncontrada.id, selectedUbicacion.id, it.precio, "valor")
              preciosActualizados.push(it.descripcion)
            } catch (error) {
              console.error(`Error actualizando precio para ${it.descripcion}:`, error)
            }
          }

          // Calcular el precio a enviar según si está facturando en negro o no
          const itemIvaPercentage = it.ivaPercentage || 21
          const precioParaEnviar = checkboxFacturaNegro
            ? truncateToTwoDecimals(it.precio / (1 + itemIvaPercentage / 100) * (1 - (it.porcentajeDescuento || 0) / 100)) // Precio sin IVA
            : it.precio // Precio original

          // ✅ Calcular el valor del impuesto sobre el monto unitario
          const valorImpuestoUnitario = checkboxFacturaNegro
            ? truncateToTwoDecimals((it.precio - precioParaEnviar) * (1 - (it.porcentajeDescuento || 0) / 100)) // Diferencia entre precio con IVA y sin IVA
            : truncateToTwoDecimals(precioParaEnviar * (itemIvaPercentage / 100)) // IVA sobre el precio unitario

          if (existingItemIds.includes(it.idItem)) {
            console.log("updateTransaccionItem")
            await updateTransaccionItem(idTransaccion, it.idItem, {
              cantidad: it.cantidad,
              precio: precioParaEnviar,
              porcentajeDescuento: it.porcentajeDescuento,
            })
            // ✅ Solo actualizar impuesto del item si se está facturando
            if (checkboxFacturaNegro === true) {
              await updateTransaccionImpuestoItem(idTransaccion, it.idItem, {
                idImpuesto: it.impuestoData.idIva,
                porcentaje: it.impuestoData.porcentaje,
                montoTotal: valorImpuestoUnitario
              })
            }
          } else {
            console.log("postTransaccionItem")
            await postTransaccionItem(idTransaccion, it.idItem, it.cantidad, precioParaEnviar, it.porcentajeDescuento)
            // ✅ Solo crear impuesto del item si se está facturando
            console.log("se ejecuta postTransaccionItemImpuestoCoso")
            if (checkboxFacturaNegro === true) {
              console.log("se ejecuta postTransaccionItemImpuestoCoso")
              await postTransaccionImpuestoItem(idTransaccion, it.idItem, it.impuestoData.idIva, it.impuestoData.porcentaje, valorImpuestoUnitario)
            }
          }
        }
      }

      // Actualizar impuestos de los items si han sido modificados
      console.log("Actualizando impuestos de items...")
      const impuestosActualizados = []

      for (const itemId in impuestosModificados) {
        const cambio = impuestosModificados[itemId]
        console.log(`Verificando cambio para item ${itemId}:`, cambio)

        if (cambio && cambio.porcentajeNuevo !== undefined) {
          try {
            console.log(`Actualizando impuesto del item ${itemId} de ${cambio.porcentajeOriginal}% a ${cambio.porcentajeNuevo}%`)

            // Buscar el impuesto original del item para obtener el ID correcto
            const itemImpuestoOriginal = itemImpuestos[itemId];
            console.log(`Impuesto original del item ${itemId}:`, itemImpuestoOriginal)

            const idImpuestoParaActualizar = itemImpuestoOriginal?.idImpuesto || cambio.idImpuesto;
            console.log(`ID de impuesto para actualizar:`, idImpuestoParaActualizar)

            if (idImpuestoParaActualizar) {
              await updateImpuestoItem(
                itemId,
                idImpuestoParaActualizar,
                cambio.porcentajeNuevo
              )
              impuestosActualizados.push(cambio.descripcion)
            } else {
              console.log(`No se pudo actualizar impuesto del item ${itemId}: no se encontró ID de impuesto`)
            }
          } catch (error) {
            console.error(`Error al actualizar impuesto del item ${itemId}:`, error)
          }
        } else {
          console.log(`Cambio no válido para item ${itemId}:`, cambio)
        }
      }

      // Mostrar notificación de impuestos actualizados
      if (impuestosActualizados.length > 0) {
        withReactContent(Swal).fire({
          position: "bottom-end",
          icon: "success",
          text: `Impuestos actualizados para: ${impuestosActualizados.join(', ')}`,
          showConfirmButton: false,
          timer: 3000,
          width: 400,
        })
      }

      const transaccionData = {
        id: idTransaccion,
        cliente: entidadEncontrada.descripcion,
        tipoMedioDePago: [],
        montoDescuento: tempValorDescuento,
        porcentajeDescuento: tempPorcentajeDescuento,
        fecha: new Date().toLocaleDateString(),
      }
      console.log('itemList', itemList)
      setTransaccionData(transaccionData)
      setItemsTransaccion(itemList)

      // Paso 2: Abrir el modal
      setOpenModal(true)

      setSelectedItem(null)
      setSearchText("")
      setItemList([])
      setDniCliente("")
      setValorDescuento(0)
      setPorcentajeDescuento(0)
      setTempValorDescuento("0")
      setTempPorcentajeDescuento("0")
      setPrecioBaseTotal(0)
      setMontoTotalDescuentos(0)
      setAplicarDescuento(false)

      console.log("Transacción creada y stock actualizado correctamente.")

      // Limpiar el estado de impuestos modificados
      setImpuestosModificados({})
      setItemImpuestos({})
    } catch (error) {
      if (error.response) {
        console.error("Error en la respuesta del servidor:", error.response.data)
      } else if (error.request) {
        console.error("Error en la solicitud:", error.request)
      } else {
        console.error("Error en la configuración:", error.message)
      }
    }
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const crearVentaIgualmente = () => {
    handleTransaccionSubmit(false)
  }

  // Modificar la función handleAddItem para incluir la lógica de precios basada en el cliente
  const handleAddItem = async () => {
    try {


      // Verifica que haya un ítem seleccionado y que se haya ingresado cantidad
      if (selectedItem) {
        console.log(selectedItem)

        // Obtener el impuesto del item de forma segura
        let itemImpuesto = null
        try {
          itemImpuesto = await getImpuestoItem(selectedItem.id)
          console.log("Impuesto del item:", itemImpuesto)

          // Guardar el impuesto en el estado
          setItemImpuestos(prev => ({
            ...prev,
            [selectedItem.id]: itemImpuesto
          }))
        } catch (error) {
          console.log("No se encontró impuesto específico para el item:", selectedItem.id)
          // Si falla, usar el IVA por defecto sin romper el flujo
          itemImpuesto = {
            idItem: selectedItem.id,
            idImpuesto: null,
            porcentaje: 21,
            descripcionImpuesto: "IVA General"
          }
        }

        // Obtiene la información de la ubicación del ítem (asincrónico)
        console.log(selectedUbicacion)
        const ubicacionItem = await getItemUbicacionFilterByUbicacion(selectedItem.id, selectedUbicacion.id)

        // Obtener el precio de lista según el cliente seleccionado
        const precioListaItem = await getListaMontosByIdItemIdEntidad(
          dniCliente?.id,
          selectedItem.id,
          selectedUbicacion.id,
        )



        console.log(ubicacionItem[0])

        const stockDisponible = ubicacionItem ? ubicacionItem[0].inventario : "No disponible"
        // Usar el precio de lista si existe, de lo contrario usar el precio de ubicación
        const precioItem = precioListaItem ? precioListaItem.monto : 0

        // Verifica si hay datos válidos
        if (stockDisponible === "No disponible" || precioItem === "No disponible") {
          ErrorModal("productoNoEncontrado")
          return
        }

        // Verifica si el ítem ya existe en itemList
        const existingItemIndex = itemList.findIndex(
          (it) => it.idItem === selectedItem.id && it.idUbicacion === selectedUbicacion.id,
        )

        if (existingItemIndex !== -1) {
          // Si el ítem existe, actualiza su cantidad
          await handleUpdateItem(
            existingItemIndex,
            undefined,
            Number(itemList[existingItemIndex].cantidad) + 1,
            undefined,
          )
        } else {
          // Construye el nuevo ítem usando el impuesto específico del item
          const itemIvaPercentage = checkboxFacturaNegro ? (itemImpuesto?.porcentaje || 21) : 0
          const precioSinIva = checkboxFacturaNegro
            ? truncateToTwoDecimals(precioItem / (1 + itemIvaPercentage / 100) * (1 - 0 / 100))
            : precioItem
          const montoIva = checkboxFacturaNegro ? truncateToTwoDecimals(precioSinIva * (itemIvaPercentage / 100)) : 0

          // Buscar si el impuesto actual coincide con algún impuesto de AFIP
          const impuestosAFIP = getIvaAFIP();
          const impuestoAFIPCoincidente = impuestosAFIP.find(imp =>
            Math.abs(imp.porcentaje - itemIvaPercentage) < 0.01
          );

          const newItem = {
            descripcion: selectedItem.descripcion,
            cantidad: 1,
            stock: stockDisponible,
            precio: precioItem,
            precioSinIva: precioSinIva, // Nuevo campo
            montoIva: montoIva, // Nuevo campo
            codigo: selectedItem.codigo,
            porcentajeDescuento: 0,
            idItem: selectedItem.id,
            idUbicacion: selectedUbicacion.id,
            ivaPercentage: itemIvaPercentage,
            ubicacion: selectedUbicacion.label,
            // Información adicional del impuesto para manejar cambios
            impuestoData: {
              idImpuesto: impuestoAFIPCoincidente?.id || itemImpuesto?.idImpuesto || null,
              porcentaje: itemIvaPercentage,
              descripcionImpuesto: impuestoAFIPCoincidente?.descripcion || itemImpuesto?.descripcionImpuesto || "IVA General",
              idIva: impuestoAFIPCoincidente?.idIva || 1,
            }
          }

          // Actualiza la lista de ítems
          const updatedItems = [newItem, ...itemList]

          // Recalcula el precio total usando la función updateTotals
          updateTotals(updatedItems)

          // Recalcular cantidad total de ítems seleccionados
          const updatedCantidadItem = updatedItems.reduce((cantidadItems, item) => cantidadItems + item.cantidad, 0)

          // Actualiza los estados
          setCantidadItemsSelect(updatedCantidadItem)
          setItemList(updatedItems)
          setCantidadItemsInvocados(updatedItems.length)


        }

        // Resetea los campos
        setSelectedItem(null)
        if (autocompleteRef.current) {
          autocompleteRef.current.focus()
        }
      }
    } catch (error) {
      console.error("Error al agregar el ítem:", error)
      ErrorModal("itemUbicaciones")
    }
  }

  const ProductoNoEncontrado = () => {
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "error",
      text: "Producto no encontrado",
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }



  const handleUpdateItem = async (index, newDescripcion, newCantidad, newDescuento) => {
    const updatedItems = await Promise.all(
      itemList.map(async (it, i) => {
        if (i === index) {
          try {
            // Recalcular IVA si es necesario
            const itemIvaPercentage = it.ivaPercentage || 21
            const precioSinIva = checkboxFacturaNegro
              ? truncateToTwoDecimals(it.precio / (1 + itemIvaPercentage / 100) * (1 - (it.porcentajeDescuento || 0) / 100))
              : it.precio
            const montoIva = checkboxFacturaNegro ? truncateToTwoDecimals(precioSinIva * (itemIvaPercentage / 100)) : 0

            return {
              ...it,
              descripcion: it.descripcion,
              cantidad: newCantidad !== undefined ? Number(newCantidad) : it.cantidad,
              stock: it.stock,
              precio: it.precio,
              precioSinIva: precioSinIva, // Mantener campo
              montoIva: montoIva, // Mantener campo
              codigo: it.codigo,
              porcentajeDescuento: newDescuento !== undefined ? Number(newDescuento) : it.porcentajeDescuento,
              idItem: it.idItem,
              ivaPercentage: itemIvaPercentage,
            }
          } catch (error) {
            console.error("Error al actualizar el ítem:", error)
          }
        }
        return it
      }),
    )

    // Recalcula la cantidad total de ítems seleccionados
    const updatedCantidadItem = updatedItems.reduce((cantidadItems, item) => cantidadItems + item.cantidad, 0)

    // Actualizar el estado según el contexto
    if (id) {
      setCantidadItemsSelect(updatedCantidadItem)
      setFilteredTransaccionItems(updatedItems)
      setItemList(updatedItems)
      updateTotals(updatedItems)
    } else {
      setCantidadItemsSelect(updatedCantidadItem)
      setItemList(updatedItems)
      updateTotals(updatedItems)
    }
  }

  // 🔒 Función para actualizar el precio de un item específico
  const handleUpdateItemPorPrecio = async (index, newPrecio) => {
    try {
      // Validar y limpiar el precio
      const precioNumerico = Number.parseFloat(newPrecio)
      if (isNaN(precioNumerico) || precioNumerico <= 0) {
        ErrorModal("productoNoEncontrado") // Reutilizar modal de error existente
        return
      }

      const updatedItems = await Promise.all(
        itemList.map(async (it, i) => {
          if (i === index) {
            // Recalcular IVA si es necesario
            const itemIvaPercentage = it.ivaPercentage || 21
            const precioSinIva = checkboxFacturaNegro
              ? truncateToTwoDecimals(precioNumerico / (1 + itemIvaPercentage / 100) * (1 - (it.porcentajeDescuento || 0) / 100))
              : precioNumerico
            const montoIva = checkboxFacturaNegro ? truncateToTwoDecimals(precioSinIva * (itemIvaPercentage / 100)) : 0

            return {
              ...it,
              precio: precioNumerico,
              precioSinIva: precioSinIva,
              montoIva: montoIva,
            }
          }
          return it
        }),
      )

      // Actualizar el estado según el contexto
      if (id) {
        setFilteredTransaccionItems(updatedItems)
        setItemList(updatedItems)
      } else {
        setItemList(updatedItems)
      }

      // Recalcular totales después de actualizar el precio
      updateTotals(updatedItems)
    } catch (error) {
      console.error("Error actualizando el precio del item:", error)
      ErrorModal("itemUbicaciones")
    }
  }

  // Eliminar ítem individual
  const handleDeleteItem = (index) => {
    const updatedItems = itemList.filter((_, i) => i !== index)
    setItemList(updatedItems)

    // Recalcular totales con la nueva lista
    updateTotals(updatedItems)

    const updatedCantidadItem = updatedItems.reduce((cantidadItems, item) => cantidadItems + item.cantidad, 0)
    setCantidadItemsSelect(updatedCantidadItem)
    setCantidadItemsInvocados(updatedItems.length)
  }

  // Eliminar todos los ítems
  const handleDeleteAllItems = () => {
    setItemList([])
    setPrecioTotal(0)
    setPrecioBaseTotal(0)
    setCantidadItemsSelect(0)
    setCantidadItemsInvocados(0)
  }

  const controlarDniIngresadoSiExiste = () => {
    console.log(dniCliente)
    if (dniCliente) {
      setEntidadExistente(dniCliente)
      setAbrirModalEntidadCliente(true) // Muestra el modal si se encuentra la entidad
    } else {
      console.log("DNI no encontrado entre los clientes")
      setEntidadExistente(null) // No hay entidad existente
      setAbrirModalEntidadCliente(true) // Muestra el modal para crear cliente si no se encuentra entidad
    }
  }

  // Función que maneja cuando se abre el modal de creación de cliente
  const handleAbrirModalCrearCliente = () => {
    setAbrirModalEntidadCliente(false) // Cierra el modal anterior
    setAbrirModalCrearCliente(true) // Abre el modal para crear cliente
    setIsEditing(false)
  }

  // Función que se ejecutará cuando se cree correctamente la entidad
  const handleCerrarModalCrearCliente = () => {
    setAbrirModalCrearCliente(false) // Cierra el modal de creación cuando el cliente se crea correctamente
  }

  const abrirModificarCliente = (entidad) => {
    setEntidadAEditar(entidad) // Guardar la entidad a editar
    setIsEditing(true) // Cambiar el estado a edición
    setAbrirModalCrearCliente(true) // Abre el modal para modificar
  }

  const autocompleteRef = useRef(null)
  const cantidadRef = useRef(null)
  const buttonRef = useRef(null)

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault() // Evitar el comportamiento por defecto de Enter

      // ✅ Si hay un item seleccionado y cantidad, agregarlo automáticamente (como en GestionGenerarVenta)
      if (selectedItem && document.activeElement !== buttonRef.current) {
        handleAddItem()
        return
      }

      if (document.activeElement === buttonRef.current) {
        // Si el botón está enfocado, volver al Autocomplete
        autocompleteRef.current.focus()
      } else {
        // Si no está en el botón, pasar al botón
        buttonRef.current.focus()
      }
    }
  }

  const handleKeyDownAndSubmit = (event) => {
    handleKeyDown(event) // Llama a handleKeyDown para manejar el enfoque
    if (event.key === "Enter") {
      handleAddItem() // Llama a la función de agregar o editar
    }
  }

  const handleCloseModalMedioPago = () => {
    setOpenModalMedioPago(false)
  }

  const handleAlerta = (exito) => {
    console.log("exito " + exito)
    if (exito == true) {
      SucessModal("crearEntidad")
    } else {
      ErrorModal("crearEntidad")
    }
  }

  const ErrorModal = (vieneDe) => {
    let error = ""
    if (vieneDe === "medioDePago") {
      error = "Falta agregar un medio de pago"
    }
    if (vieneDe === "productoNoEncontrado") {
      error = "Producto no encontrado"
    }
    if (vieneDe === "crearEntidad") {
      error = "Error en CREAR/ACTUALIZAR la entidad"
    }
    if (vieneDe === "itemUbicaciones") {
      error = "No se encuentra item en la ubicacion seleccionada"
    }
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "error", // Cambié a "error" porque es un mensaje de error.
      text: error, // Pasa la cadena directamente, no como un objeto.
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }

  const SucessModal = (vieneDe) => {
    let success = ""
    if (vieneDe === "crearEntidad") {
      success = "Se CREO/ACTUALIZO la entidad correctamente"
    }
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "success", //
      text: success, // Pasa la cadena directamente, no como un objeto.
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }

  useEffect(() => {
    console.log(dniCliente)
  }, [dniCliente])

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "#f5f5f5",
        position: "relative",
        padding: 2,
      }}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          handleTransaccionSubmit(true)
        }}
      >
        <Grid container spacing={2}>
          {/* Left Column - Products */}
          <Grid item xs={12} md={9}>
            <Card className="cardMenuBuscarGenerarVentas" elevation={3} sx={{ mb: 2, borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                  <ReceiptIcon sx={{ mr: 1, color: "rgb(244, 177, 14)" }} />
                  Generar Presupuesto
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1, p: 1, borderRadius: 1 }}>
                  <Autocomplete
                    size="small"
                    fullWidth={!checkboxFacturaNegro}
                    sx={{ flexGrow: checkboxFacturaNegro ? 1 : undefined }}
                    disablePortal
                    options={entidadesClientesTresLetras.map((it) => ({
                      label: `${it.descripcion} - ${it.apellido} - ${it.dniCuitCuil}`,
                      descripcion: it.descripcion,
                      dniCuitCuil: it.dniCuitCuil,
                      id: it.id,
                      apellido: it.apellido,
                      telefono: it.telefono || null,
                      email: it.email || null,
                      direccion: it.direccion || null,
                      localidad: it.localidad || null,
                      provincia: it.provincia || null,
                      idTipoEntidad: it.idTipoEntidad,
                    }))}
                    value={dniCliente}
                    onChange={(event, newValue) => {
                      setDniCliente(newValue)
                    }}
                    onInputChange={(event, newInputValue) => setSearchTextCliente(newInputValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Cliente - DNI / CUIT / CUIL"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <PersonIcon color="action" sx={{ ml: 1, mr: 0.5 }} />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                  <IconButton onClick={controlarDniIngresadoSiExiste} sx={{ ml: 1, color: "rgb(244, 177, 14)" }}>
                    <PersonAddAltIcon />
                  </IconButton>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: checkboxFacturaNegro ? "auto" : "10%",
                      justifyContent: "center",
                    }}
                  >
                    <Typography sx={{ mb: 0, mr: 1 }}>F</Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkboxFacturaNegro}
                          onChange={(e) => {
                            setCheckboxFacturaNegro(e.target.checked)
                            if (e.target.checked) {
                              // Actualizar todos los items con el IVA por defecto
                              const updatedItems = itemList.map((item) => ({
                                ...item,
                                ivaPercentage: 21,
                              }))
                              setItemList(updatedItems)
                            }
                          }}
                        />
                      }
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    gap: 1,
                    backgroundColor: alpha("#f5f5f5", 0.5),
                    p: 1,
                    borderRadius: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Autocomplete
                    size="small"
                    disablePortal
                    options={[
                      // ✅ Top 10 items más vendidos (como en GestionGenerarVenta)
                      ...(topItemsVentas || []).map((it) => ({
                        label: `${it.descripcion}`,
                        descripcion: it.descripcion,
                        codigo: it.codigo,
                        id: it.id,
                        codigoScanner: it.codigoScanner,
                        isTopItem: true,
                      })),
                      // Items regulares
                      ...(itemTresLetras || []).map((it) => ({
                        label: generateItemLabel(it),
                        descripcion: it.descripcion,
                        codigo: it.codigo,
                        id: it.id,
                        codigoScanner: it.codigoScanner,
                        isTopItem: false,
                      }))
                    ]}
                    value={selectedItem}
                    onChange={async (event, newValue) => {
                      setSelectedItem(newValue)

                    }}
                    onInputChange={(event, newInputValue) => setSearchText(newInputValue)}
                    sx={{ flexGrow: 1 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Buscar producto"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <SearchIcon color="action" sx={{ ml: 1, mr: 0.5 }} />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                        inputRef={autocompleteRef}
                        onKeyDown={handleKeyDown}
                      />
                    )}
                  />
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Autocomplete
                      size="small"
                      disablePortal
                      options={ubicaciones.map((it) => ({
                        id: it.id,
                        label: it.descripcion,
                      }))}
                      value={selectedUbicacion}
                      onChange={(event, newValue) => {
                        setSelectedUbicacion(newValue)
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Ubicación" size="small" sx={{ width: 150 }} />
                      )}
                    />
                    <Autocomplete
                      size="small"
                      disablePortal
                      options={negocios.map((it) => ({
                        id: it.id,
                        label: it.descripcion,
                      }))}
                      value={selectedNegocio}
                      onChange={(event, newValue) => {
                        setSelectedNegocio(newValue)
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Negocio" size="small" sx={{ width: 150 }} />
                      )}
                    />
                  </Box>
                  <Button
                    variant="contained"
                    onClick={handleAddItem}
                    ref={buttonRef}
                    onKeyDown={handleKeyDownAndSubmit}
                    startIcon={<AddShoppingCartIcon />}
                    sx={{ backgroundColor: "#5b5b5f", color: "white" }}
                  >
                    Agregar
                  </Button>
                </Box>
              </CardContent>
            </Card>

            <Card elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
              {/* Modificando TableContainer para que use toda la altura disponible de la pantalla */}
              <TableContainer
                sx={{
                  maxHeight: {
                    xs: "calc(100vh - 300px)", // En móviles, usa toda la altura menos espacio para otros elementos
                    md: "calc(100vh - 250px)", // En desktop, usa toda la altura menos espacio para otros elementos
                  },
                  overflowX: "auto",
                  overflowY: "auto", // Asegura que aparezca scroll vertical cuando sea necesario
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Producto</StyledTableCell>
                      <StyledTableCell align="right">Cantidad</StyledTableCell>
                      <StyledTableCell align="right">Stock</StyledTableCell>
                      <StyledTableCell align="right">Precio Unit.</StyledTableCell>
                      {checkboxFacturaNegro && <StyledTableCell align="right">IVA %</StyledTableCell>}
                      <StyledTableCell align="right">Descuento</StyledTableCell>
                      <StyledTableCell align="right">Total</StyledTableCell>
                      <StyledTableCell align="center">Acciones</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {itemList.length > 0 ? (
                      itemList.map((it, index) => {
                        // Calcular precio unitario sin IVA cuando checkboxFacturaNegro es true
                        // Usar el impuesto específico del item si está disponible, sino usar el por defecto
                        const itemIvaPercentage = it.impuestoData?.porcentaje || it.ivaPercentage || 21
                        const precioSinIva = checkboxFacturaNegro
                          ? truncateToTwoDecimals(it.precio / (1 + itemIvaPercentage / 100) * (1 - (it.porcentajeDescuento || 0) / 100))
                          : it.precio
                        const montoIva = checkboxFacturaNegro
                          ? truncateToTwoDecimals(precioSinIva * (itemIvaPercentage / 100))
                          : 0

                        return (
                          <StyledTableRow key={index}>
                            <TableCell>
                              <Typography variant="body2" fontWeight="medium">
                                {it.codigo} - {it.descripcion}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <TextField
                                type="number"
                                value={cantidadInputs[index] ?? ""}
                                size="small"
                                onChange={e => {
                                  setCantidadInputs(prev => ({
                                    ...prev,
                                    [index]: e.target.value              // no tocas itemList todavía
                                  }));
                                }}
                                inputProps={{
                                  step: "0.001",
                                  min: "0.001",
                                }}
                                onBlur={() => {
                                  const raw = cantidadInputs[index] ?? ""
                                  const parsed = Number.parseFloat(raw);
                                  // si quedó vacío, decides si restituir el anterior o forzar 0
                                  const finalValue = isNaN(parsed) || parsed <= 0 ? itemList[index].cantidad : parsed;
                                  handleUpdateItem(
                                    index,
                                    itemList[index].descripcion,
                                    finalValue,
                                    itemList[index].descuento
                                  );
                                  // y sincronizas el input string con el valor final
                                  setCantidadInputs(prev => ({
                                    ...prev,
                                    [index]: finalValue.toString()
                                  }));
                                }}
                                sx={{
                                  width: 80,
                                  "& .MuiInputBase-root": {
                                    borderRadius: 1,
                                  },
                                }}
                              />
                            </TableCell>
                            <TableCell align="right">{it.stock}</TableCell>
                            <TableCell align="right">
                              {precioEnPresupuestoEditable ? (
                                <TextField
                                  type="number"
                                  defaultValue={it.precio || 0}
                                  size="small"
                                  onBlur={(e) => handleUpdateItemPorPrecio(index, e.target.value)}
                                  sx={{
                                    width: 120,
                                    "& .MuiInputBase-root": {
                                      borderRadius: 1,
                                      height: 32,
                                    },
                                  }}
                                  InputProps={{
                                    startAdornment: <span>$</span>,
                                    inputProps: {
                                      step: "any", //permite decimales
                                      min: 0,
                                    },
                                  }}
                                />
                              ) : (
                                checkboxFacturaNegro ? (
                                  <Box>
                                    <Typography variant="body2" sx={{ fontSize: "low", fontWeight: "BOLD" }}>
                                      Sin IVA:{" "}
                                      {new Intl.NumberFormat("es-AR", {
                                        style: "currency",
                                        currency: "ARS",
                                      }).format(precioSinIva)}
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                                      IVA:{" "}
                                      {new Intl.NumberFormat("es-AR", {
                                        style: "currency",
                                        currency: "ARS",
                                      }).format(truncateToTwoDecimals(
                                        it.precio * it.cantidad * (1 - (it.porcentajeDescuento || 0) / 100),
                                      ) - precioSinIva)}
                                    </Typography>
                                  </Box>
                                ) : (
                                  new Intl.NumberFormat("es-AR", {
                                    style: "currency",
                                    currency: "ARS",
                                  }).format(it.precio)
                                )
                              )}
                            </TableCell>
                            {checkboxFacturaNegro && (
                              <TableCell align="right">
                                <Box sx={{ position: 'relative' }}>
                                  <FormControl size="small" sx={{ minWidth: 120 }}>
                                    <Select
                                      value={itemIvaPercentage}
                                      onChange={(e) => {
                                        const newIvaPercentage = Number.parseFloat(e.target.value) || 0
                                        // Usar la función específica para actualizar impuesto
                                        handleUpdateItemImpuesto(index, newIvaPercentage)
                                      }}
                                      displayEmpty
                                      sx={{
                                        "& .MuiInputBase-root": {
                                          borderRadius: 1,
                                        },
                                      }}
                                    >
                                      {getImpuestosValidosParaItem(it.idItem, it.impuestoData).map((impuesto) => (
                                        <MenuItem key={impuesto.id} value={impuesto.porcentaje}>
                                          {impuesto.porcentaje}%
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                  {impuestosModificados[it.idItem] && (
                                    <Box
                                      sx={{
                                        position: 'absolute',
                                        top: -8,
                                        right: -8,
                                        backgroundColor: '#ff9800',
                                        color: 'white',
                                        borderRadius: '50%',
                                        width: 16,
                                        height: 16,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '10px',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      !
                                    </Box>
                                  )}
                                </Box>
                              </TableCell>
                            )}
                            <TableCell align="right">
                              <TextField
                                type="number"
                                value={it.porcentajeDescuento || 0}
                                size="small"
                                onChange={(e) => {
                                  const newValue = e.target.value;
                                  const updatedItems = [...itemList];
                                  updatedItems[index] = {
                                    ...updatedItems[index],
                                    porcentajeDescuento: Number(newValue) || 0
                                  };
                                  setItemList(updatedItems);
                                }}
                                onBlur={(e) => handleUpdateItem(index, it.descripcion, it.cantidad, e.target.value)}
                                sx={{
                                  width: 80,
                                  "& .MuiInputBase-root": {
                                    borderRadius: 1,
                                  },
                                }}
                                InputProps={{ endAdornment: <span>%</span> }}
                              />
                            </TableCell>
                            <TableCell align="right">
                              <Typography fontWeight="medium">
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(
                                  truncateToTwoDecimals(
                                    it.precio * it.cantidad * (1 - (it.porcentajeDescuento || 0) / 100),
                                  ),
                                )}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <IconButton color="error" size="small" onClick={() => handleDeleteItem(index)}>
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </StyledTableRow>
                        )
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={checkboxFacturaNegro ? 8 : 7} align="center" sx={{ py: 3 }}>
                          <Typography variant="body1" color="text.secondary">
                            No hay productos agregados
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Busque y agregue productos para comenzar el presupuesto
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TableCell colSpan={checkboxFacturaNegro ? 8 : 7} align="right">
                        <Button
                          variant="outlined"
                          color="error"
                          startIcon={<DeleteIcon />}
                          onClick={handleDeleteAllItems}
                          disabled={itemList.length === 0}
                          sx={{ mt: 1, mb: 1 }}
                        >
                          Eliminar todos
                        </Button>
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Card>

            {itemList.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                  p: 2,
                  bgcolor: "white",
                  borderRadius: 2,
                  boxShadow: 1,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="#5b5b5f">
                    ITEMS:
                  </Typography>
                  <Typography variant="subtitle1" fontWeight="bold" color="rgb(244, 177, 14)">
                    {itemList.length}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="#5b5b5f">
                    CANTIDAD ITEMS:
                  </Typography>
                  <Typography variant="subtitle1" fontWeight="bold" color="rgb(244, 177, 14)">
                    {itemList.reduce((total, item) => total + item.cantidad, 0)}
                  </Typography>
                </Box>
              </Box>
            )}
          </Grid>

          {/* Right Column - Summary and Actions */}
          <Grid item xs={12} md={3}>
            <Card elevation={3} sx={{ borderRadius: 2, mb: 2 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                  <ReceiptIcon sx={{ mr: 1, color: "rgb(244, 177, 14)" }} />
                  Resumen de Presupuesto
                </Typography>

                <Box
                  sx={{
                    backgroundColor: alpha("#f5f5f5", 0.5),
                    p: 2,
                    borderRadius: 1,
                    mb: 2,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Typography variant="body1">Subtotal:</Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(precioBaseTotal)}
                    </Typography>
                  </Box>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={aplicarDescuento}
                        onChange={(e) => {
                          const isChecked = e.target.checked
                          setAplicarDescuento(isChecked)
                          
                          // Limpiar descuentos al desmarcar
                          if (!isChecked) {
                            limpiarDescuentosItems()
                          }
                        }}
                        color="primary"
                      />
                    }
                    label="Aplicar Descuento"
                  />

                  <Collapse in={aplicarDescuento} timeout={300}>
                    <Box sx={{ mt: 1, mb: 1, display: 'flex', gap: 1, alignItems: 'center' }}>
                      <TextField
                        label="Descuento en Porcentaje (%)"
                        type="number"
                        value={tempPorcentajeDescuento}
                        onChange={(e) => setTempPorcentajeDescuento(e.target.value)}
                        onBlur={applyDiscounts}
                        InputProps={{ inputProps: { step: 0.01 } }}
                        fullWidth
                        size="small"
                      />
                      <Tooltip title="Limpiar todos los descuentos">
                        <IconButton 
                          onClick={limpiarDescuentosItems}
                          color="primary"
                          size="small"
                          sx={{ 
                            border: '1px solid',
                            borderColor: 'primary.main',
                            borderRadius: 1
                          }}
                        >
                          <RestartAltIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Collapse>

                  {/* Mostrar Total Descuentos si hay descuentos */}
                  {montoTotalDescuentos > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                        color: 'error.main'
                      }}
                    >
                      <Typography variant="body2">Total Descuentos:</Typography>
                      <Typography variant="body2" fontWeight="medium">
                        -{new Intl.NumberFormat("es-AR", {
                          style: "currency",
                          currency: "ARS",
                        }).format(montoTotalDescuentos)}
                      </Typography>
                    </Box>
                  )}

                  <Divider sx={{ my: 1 }} />

                  <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                    <Typography variant="h6">TOTAL:</Typography>
                    <Typography variant="h6" color="rgb(244, 177, 14)" fontWeight="bold">
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(precioTotal)}
                    </Typography>
                  </Box>
                </Box>

                {id ? (
                  <Button
                    variant="contained"
                    type="submit"
                    fullWidth
                    size="large"
                    startIcon={<ReceiptIcon />}
                    sx={{
                      py: 1.5,
                      borderRadius: 2,
                      fontWeight: "bold",
                      boxShadow: 3,
                      backgroundColor: Object.keys(impuestosModificados).length > 0 ? "#ff9800" : "#5b5b5f",
                      color: "white",
                      "&:hover": {
                        backgroundColor: Object.keys(impuestosModificados).length > 0 ? "#f57c00" : "#4a4a4a",
                      },
                    }}
                  >
                    {Object.keys(impuestosModificados).length > 0
                      ? `ACTUALIZAR PRESUPUESTO (${Object.keys(impuestosModificados).length} impuesto${Object.keys(impuestosModificados).length > 1 ? 's' : ''} pendiente${Object.keys(impuestosModificados).length > 1 ? 's' : ''})`
                      : "ACTUALIZAR PRESUPUESTO"
                    }
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    type="submit"
                    fullWidth
                    size="large"
                    startIcon={<ReceiptIcon />}
                    sx={{
                      py: 1.5,
                      borderRadius: 2,
                      fontWeight: "bold",
                      boxShadow: 3,
                      backgroundColor: Object.keys(impuestosModificados).length > 0 ? "#ff9800" : "#5b5b5f",
                      color: "white",
                      "&:hover": {
                        backgroundColor: Object.keys(impuestosModificados).length > 0 ? "#f57c00" : "#4a4a4a",
                      },
                    }}
                  >
                    {Object.keys(impuestosModificados).length > 0
                      ? `GENERAR PRESUPUESTO (${Object.keys(impuestosModificados).length} impuesto${Object.keys(impuestosModificados).length > 1 ? 's' : ''} pendiente${Object.keys(impuestosModificados).length > 1 ? 's' : ''})`
                      : "GENERAR PRESUPUESTO"
                    }
                  </Button>
                )}

                <Button
                  variant="outlined"
                  color="error"
                  fullWidth
                  size="large"
                  startIcon={<DeleteIcon />}
                  onClick={handleDeleteAllItems}
                  sx={{
                    mt: 2,
                    py: 1.5,
                    borderRadius: 2,
                    fontWeight: "bold",
                  }}
                >
                  ELIMINAR ÍTEMS
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </form>

      {/* Modales */}
      <ModalEntidadCliente
        open={abrirModalEntidadCliente}
        handleClose={() => setAbrirModalEntidadCliente(false)}
        esClienteExistente={!!entidadExistente}
        entidad={entidadExistente}
        abrirCrearCliente={handleAbrirModalCrearCliente}
        crearVentaIgualmente={crearVentaIgualmente}
        abrirModificarCliente={abrirModificarCliente}
        deDondeViene="PRESUPUESTO"
        tipoEntidad="cliente"
      />

      <CrearEntidadClienteModalComponent
        open={abrirModalCrearCliente}
        handleClose={handleCerrarModalCrearCliente}
        entidad={entidadAEditar}
        isEditing={isEditing}
        handleAlerta={handleAlerta}
        tipoEntidad="cliente"
      />

      {openModal && (
        <ModalFacturaComponent
          open={openModal}
          handleClose={handleCloseModal}
          transaccionData={transaccionData}
          itemsTransaccion={itemsTransaccion}
          entidadParaFactura={entidadFactura}
          usuarioParaFactura={null}
          tipoDeFactura={true}
          deDondeViene={"presupuesto"}
        />
      )}

      {/* Loading Overlay */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              p: 3,
              borderRadius: 2,
              bgcolor: "background.paper",
            }}
          >
            <CircularProgress size={60} sx={{ mb: 2 }} />
            <Typography variant="h6">Cargando...</Typography>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default GestionGenerarPresupuestoComponent
